export const environment = {
  authConfig: {
    loginUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/authorize',
    tokenUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/token',
    logoutUrl: 'https://reseau-rec.prodemial.fr/cas/logout',
    clientId: 'c3nxwh3agx.stellium',
    authGroup: 'APP_MYAPP',
    consultantGroups: ['CN=GOF_CONSULTANT'],
    backOfficeGroups: [
      'CN=APP_PLACEMENT_BACKOFFICE_COURTAGE_RECETTE',
      'CN=APP_PLACEMENT_BACKOFFICE_INVEST_RECETTE',
      'CN=APP_PLACEMENT_BACKOFFICE_RECETTE',
    ],
    backOfficeAdminGroups: ['CN=APP_PLACEMENT_BACKOFFICE_ADMIN_RECETTE'],
  },
  backEndUrl: 'https://business-gateway-api.int.finzzle-groupe.com/graphql',
  myStelliumApiUrl: 'https://mystellium-api.int.finzzle-groupe.com/graphql',
  appInsightsKey: 'f80fb188-d91e-4542-83f0-f79dfafa7aea',
  arianeFicheBaseUrl: 'https://advisor-0-metier.manymore.fr',
  prodemialProfilUrl: 'https://my-int.prodemial.fr/profil',
  zendeskUrl: 'https://prodemial.zendesk.com/hc/fr/articles/360020632439-Contacter-les-services-internes',
  notesVersions: 'https://prodemial.zendesk.com/hc/fr/articles/27699683163036--Evolutions-de-Proxeema',
  authoriseSignature: true,
  env: 'int',
  signatureTestMail: 'remy.badr@finzzle-digital.com',
  signatureTestPhone: '0647273418',
  appVersion: 'int',
  displayMyStelliumEvol: true,
  watchMyStelliumGraph: false,
  featureTags: ['activateOperationFeatures'],
};
